import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { Subject, forkJoin,filter, debounceTime, takeUntil } from 'rxjs';
import { BillingStatus, UserPermission } from 'src/app/enums/enums';
import { FilterPipe } from 'src/app/pipes/list-filter-pipe/list-filter-pipe';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { CsvService } from 'src/app/services/csv-service/csv.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { generatePdf} from 'src/app/utils/common.utils';
import { modivcareReport} from 'src/app/components/reports/pdf-make-reports/modivecare-report';
import { getSkippedItemsHtml } from 'src/app/utils/skipped-alert.utils';
import { urls } from 'src/app/utils/url.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-fs-billing-list',
  templateUrl: './fs-billing-list.component.html',
  styleUrls: ['./fs-billing-list.component.css']
})
export class FsBillingListComponent {
isTripDetailModal: boolean = false;
  selectedTrips: any = [];
  tripId: any;
  search: any;
  trips: any = [];
  fundingSources:any;
  spacetypes: any;
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  // preMembers: any = {};
  preAppointmentType: any = {};
  preCompanies: any = {};
  preLevelOfService:any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  selectedStatus: any = '';
  payModalObj: any;
  payRelation: any;
  selectedPaymentStatus: any = '';
  selectedPaymentType: any = '';
  todayDate:any = [];
  startDate:any;
  endDate:any;
  levelofservices:any;
  selectedCompany = '';
  companies:any;
  serviceAreas : any;
  selectedServiceArea:any = ''
  selectedSpaceType:any = ''
  memberNotesObj:any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user:any;
  preFundingSource:any = {};
  timeZone:any = timeZone;
  currentDate:any = moment().tz(this.timeZone).toISOString()
  userPermission=UserPermission;
  filterdataList:any= [];
  members:any = [];
  selectedMembers: any = null;
  memberSearchQuery: any;
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  private searchSubject = new Subject<string>();
  drivers:any = [];
  preDrivers:any = {};
  vehicles:any = [];
  preVehicles:any = {};
   paramountLoader = {
    isModal: false,
    isLoading: false
  };
   rideNSafe = {
    isModal: false,
    isLoading: false
  };
  
  selectedCorporateUser:any = ''
  selectedCorporateObj:any
  preSpaceTypes = {};
  dataList = [];
  selectedFundingSource: any = '';
  billingStatus = BillingStatus;

  onway: any;
  arrived: any;
  inProgress: any;
  completed: any;
  signatureModalObj: any;
  logObj:any;
  groupByName = false;
  reportSource = '';
  rnsSingleTrip: any;
  reportLoader = {
    isLoading: false
  };


  constructor(
    private sharedDataService: SharedDataService,
    private serviceArea : ServiceAreasService,
    private credentialService : CredentialService,
    private levelOfService : LosService,
    private appointmentService: AppointmentTypeService,
    // private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private billingService: BillingService,
    private router: Router,
    private csvService: CsvService,
    private fundingSourceService: FundingSourceService,
    public permissionService: PermissionService,
    private memberService: MemberService,
    private fundingSource: FundingSourceService
  ) {

  }

  ngOnInit(): void {
    this.getUser();
    this.getFundingSources() 
     this.getAllMembers();
     this.getDrivers();
     this.getFleet();
    this.listenMemberSearch();
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      companies: this.credentialService.getPicker(queryparams),
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      // members: this.memberService.getPickerMembers(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      serviceAreas: this.serviceArea.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, members, spaceTypes, serviceAreas }: any) => {

        //  Companies
        if (companies?.results?.length) {
          this.companies = companies.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Members
        // if (members?.results?.length) {
        //   this.preMembers = members.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        // }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }

  
  

 getAllTrips(page: any) {
  this.clear();
  let queryparams: any = {
    limit: 50,
    page,
    status: ['completed','cancelled'],
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    company: this.selectedCompany || undefined,
    sortBy: 'member:asc',
  };

  if (!this.selectedCompany) {
      delete queryparams.company;
    }

  if (this.selectedCorporateUser) {
    queryparams.fundingsource = this.selectedCorporateUser;
  }
   
  if (this.selectedServiceArea) {
      queryparams.serviceArea = this.selectedServiceArea;
    }
     if (this.selectedMembers) {
      queryparams.member = this.selectedMembers;
    }
     if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }

    if (this.selectedPaymentStatus) {
      queryparams.payment = this.selectedPaymentStatus;
    }

    if (this.selectedPaymentType) {
      queryparams.paymentType = this.selectedPaymentType;
    }

   this.billingService.getFundingSourceBillingTrips(queryparams)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data && data.results) {
        this.trips = data.results.map((trip:any) => ({
          ...trip,
          onway: trip.events?.find((e:any) => e.status === 'onway'),
          arrived: trip.events?.find((e: any) => e.status === 'arrived'),
          inProgress: trip.events?.find((e: any) => e.status === 'in_progress'),
          completed: trip.events?.find((e: any) => e.status === 'completed')
        }));
        this.filterdataList = this.trips;
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    });
}

onFundingSourceChange() {
  this.selectedCorporateObj = this.preFundingSource[this.selectedCorporateUser];
  this.getAllTrips(this.currentPage);
}


  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
    }
    this.isDropdownOpen = this.selectedTrips.length > 0;
  }

 onSelectAllTrips(event: any) {
  const checked = event.target.checked;
  this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
  this.selectedTrips = checked ? [...this.filterdataList] : [];
  this.isDropdownOpen = checked;
}

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.getAllTrips(this.currentPage);
  }

  filterTrips(status?: string) {
    this.selectedStatus = status || '';
    this.getAllTrips(this.currentPage);
  }

  clear(){
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  onCompanyChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }

  openPayModal(trip: any) {
    this.payModalObj = trip;
    this.payRelation = { relationType: 'fundingsource', fundingSource: trip.fundingsource, billing: trip.id, trip: trip.trip };
  }

  onClosePayModal(evt: any) {
    this.payModalObj = null;
    this.payRelation = null;
    if (evt) {
      // the billing is now settled - pull the refreshed payment state
      this.getAllTrips(this.currentPage);
    }
  }

  onPaymentStatusChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onPaymentTypeChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onServiceAreaChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }
 
  onSpaceTypeChange(){
    this.getAllTrips(this.currentPage);
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

   closeFilterDropDown(evt:any) {
    this.isDropdownOpen = false
  }

  //  closeMenu(evt:any) {
  //   this.isDropdownOpen = false;
  // }

  editTrip(evt:any){
    this.router.navigateByUrl(`trips/${evt.id}/edit`)
  }
  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
      isActive: true,

    }
    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.members = [...this.members, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }

  onMembersChange(evt:any){
    this.selectedMembers = evt;
     this.getAllTrips(this.currentPage = 1);
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getDrivers() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getPickerDrivers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.drivers = data.results;
          this.preDrivers = this.drivers.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getFleet() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getPickerVehicles(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.vehicles = data.results;
          this.preVehicles = this.vehicles.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }

  tripDetailFile() {
    let selectedTrip;
    if (!this.selectedTrips.length)
      selectedTrip = this.trips;
    else
      selectedTrip = this.getSelectedTrips();

    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone, this.preLevelOfService, this.preSpacetypes, this.preServiceAreas, this.preFundingSource)
  }

  ngOnDestroy(): void {
  }

  hasUnpaidSelectedTrips() {
    return (this.selectedTrips || []).some((trip: any) => trip.payment?.status !== 'paid');
  }

  isGeneratingInvoice = false;

  generateInvoice() {
    if (this.isGeneratingInvoice) return;
    this.isGeneratingInvoice = true;
    const payload = {
      selectedIds: (this.selectedTrips || [])
        .filter((trip: any) => trip.payment?.status !== 'paid')
        .map((trip: any) => trip.id)
    };
    this.billingService.generateFundingSourceInvoices(payload).subscribe({
      next: (data: any) => {
        this.isGeneratingInvoice = false;
        this.isDropdownOpen = false;
        this.getAllTrips(this.currentPage);
        if (data.skippedInvoices?.length) {
          const message = `Some invoices (${data.skippedInvoices.length}) were skipped.`;
          sweetAlertWithHtml('Alert', 'This is a sample message', 'alert', 'OK', getSkippedItemsHtml(data.skippedInvoices, message));
        } else {
          sweetAlert('Success', 'The invoices of selected billings have been generated', 'success', 'OK');
        }
      },
      error: (err: any) => {
        this.isGeneratingInvoice = false;
        this.isDropdownOpen = false;
        sweetAlert('Error', err, 'error', 'OK');
      }
    });
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }

  openAdjustTrip(event:any){
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/billing/fundingsource/${event.id}/adjustTrip`])
    );
    window.open(url, "_blank");
  }


  onScroll() {
    if (this.memberSearchQuery) {
      this.memberSearch(this.memberSearchQuery);
    } else {
      this.getAllMembers();
    }
  }

   onSearch(event: any) {
      const { term } = event;
      if (term) {
        this.memberSearchSubject.next(term);
      } else {
        this.clearSearh();
      }
    }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.members = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  
    listenMemberSearch() {
      this.memberSearchSubject
        .pipe(debounceTime(1000))
        .pipe(untilDestroyed(this)).subscribe((search) => {
          this.memberSearchQuery = search;
          if (search && search.length >= 3) {
            this.members = [];
            this.memberSearchPageNumber = 1;
            this.memberSearch(search);
          }
        });
    }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }


  onSearchInput() {
    this.searchSubject.next(this.search);
  }
  
    memberSearch(search: any, id = null) {
      const queryParams: any = {
        limit: 10,
        page: this.memberSearchPageNumber
      }
  
      if (search) {
        queryParams.search = search;
      }
  
      if (id) {
        queryParams.id = id;
      }
  
      if (!this.tripId) {
        queryParams.isActive = true;
      }
  
      this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.members = [...this.members, ...data.results];
          this.memberSearchPageNumber += 1;
        }
      });
    }
  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

  clearMemberData() {
    this.selectedMembers = null;
  }

  downloadRawReport() {
    let queryparams:any = {
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    if(this.selectedCompany){
      queryparams.company = this.selectedCompany;
    }
    if(this.selectedTrips && this.selectedTrips.length){
      queryparams.selectedIds = this.selectedTrips.map((trip: any) => trip.id);
      
    }
    this.billingService.getFsReportTrips(queryparams)
      .subscribe((trips:any) => {
        if (trips && trips.length) {

          this.filterRawReportTrips(trips);
        }
      });
  }

  openParamountModal() {
  this.selectedTrips = this.filterdataList.filter((trip: any) => trip.isSelected);
  if (this.selectedTrips.length) {
    this.selectedTrips.splice(0, this.selectedTrips.length, ...this.selectedTrips);
    this.paramountLoader.isModal = true;
  }
}

openRNSModal(singleTrip?: any){
  if (singleTrip) {
    this.rnsSingleTrip = [singleTrip];
  } else {
    this.selectedTrips = this.filterdataList.filter((trip: any) => trip.isSelected);
    if (this.selectedTrips.length) {
      this.selectedTrips.splice(0, this.selectedTrips.length, ...this.selectedTrips);
    }
  }
  this.rideNSafe.isModal = true;
  this.reportSource = 'rnsinvoice'
}



  filterRawReportTrips(trips:any) {

    this.csvService.generateRawTripReport(
      trips,
      this.todayDate,
      this.timeZone,
      'fsBilling'
    );
  }


  onClose() {
    if (!this.selectedMembers && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  openSignatureModal(trip: any) {
    this.signatureModalObj = trip;
  }

  onCloseSignatureModal(evt: any) {
    if (evt) {
      this.signatureModalObj.signature = evt.signature;
    }
    this.signatureModalObj = null;
  }

  openLogModal(trip: any) {
    this.logObj = trip.id;
  }

  onGroupByNameChange(event:any){
    if(event.target.checked){
      this.groupByName = event.target.checked;
      this.getAllTrips(this.currentPage);
    }else {
      this.groupByName = false;
      this.getAllTrips(this.currentPage);
    }
  }
  
downloadForm837(trip?: any) {
  let selectedIds = [];
   let html = '';
  if (trip) {
    selectedIds.push(trip.id);
  } else {
    selectedIds = this.selectedTrips.map((t: any) => t.id);
  }
  const payload = {
    selectedIds: selectedIds,
    fundingsource: trip?.fundingsource || this.selectedCorporateUser
  };
  this.billingService.downloadForm837(payload).subscribe({
    next: (data: any) => {

      if (data) {
        const { url, fileName } = data;

        const link = document.createElement('a');
        link.href = urls.SERVER_URL + url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    error: (err: any) => {
      const errorData = err?.error?.data || [];
      const message =
        err?.error?.message || 'Missing Required Fields';

  if (errorData.length) {
        html = this.buildMissingFieldsHtml(
        errorData,
        message
      );
  }

      sweetAlertWithHtml(
        'Alert',
        message,
        'error',
        'OK',
        errorData.length ? html : ''
      );
    }
  });
}

  async downloadModivcareReport() {
    this.reportLoader.isLoading = true;
    const tripsWithDrivers = this.selectedTrips.filter(
      (trip: any) => trip.driver?.id
    );

    if(tripsWithDrivers.length === 0) {
      sweetAlert(
        'Alert',
        'There are no valid trips available for the Modivcare report.',
        'warning',
        'OK'
      );
      this.reportLoader.isLoading = false;
      return;
    }

    const groupedDrivers = tripsWithDrivers.reduce((acc: any, trip: any) => {
      const driverId = trip.driver.id;

      if (!acc[driverId]) {
        acc[driverId] = {
          driver: trip.driver,
          vehicle: trip.vehicle,
          trips: []
        };
      }

      acc[driverId].trips.push(trip);

      return acc;
    }, {});

    try {
      const detailsObject = await modivcareReport(groupedDrivers, this.selectedCorporateObj, this.user, this.preLevelOfService);
      const invoiceName = "Modivcare Report";
      await generatePdf(detailsObject, "download", invoiceName);
    } catch (err) {
      console.error("Error generating Trip report:", err);
    }
    finally {
      this.reportLoader.isLoading = false;
    }
  }

buildMissingFieldsHtml(data: any[], message: string) {

  let html = `
    <p class="mb-4">${message}</p>

    <div class="rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-2">
      
      <div class="max-h-[400px] overflow-auto rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">

        <table class="min-w-full border-separate border-spacing-0">

          <thead class="sticky top-0 z-10">

            <tr>

              <th class="px-3 py-2 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                Type
              </th>

              <th class="px-3 py-2 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                Name
              </th>

              <th class="px-3 py-2 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                Missing Fields
              </th>

            </tr>

          </thead>

          <tbody>
  `;

  data.forEach((item: any) => {

    html += `
      <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10">

        <td class="px-3 py-2 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap align-top">
          ${item.type || '-'}
        </td>

        <td class="px-3 py-2 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 align-top min-w-[250px]">
          ${item.member || '-'}
        </td>

        <td class="px-3 py-2 text-left text-sm-light border-b border-zinc-950/10 dark:border-white/10 min-w-[300px]">
          ${(item.missingFields || []).join(', ')}
        </td>

      </tr>
    `;
  });

  html += `
          </tbody>

        </table>

      </div>

    </div>

    <p class="mt-2">
      Please update the missing fields and try again.
    </p>
  `;

  return html;
}

}


